import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { WaitlistState } from '@/store/waitlist/types';

export const getters: GetterTree<WaitlistState, RootState> = {};
